/**
 * @desc 退件签收
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OutReturnSignRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/returnSigning`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
